<template>
    <div style="margin: 0 auto; margin-top: 100px; width: 500px;">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="用户名" prop="username">
          <el-input v-model.number="ruleForm.username"></el-input>
        </el-form-item>

        <el-form-item label="密 码" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"

    export default {
        name: "AdmLogin",
      data() {
          return{
            ruleForm: {
              username:'',
              pass: '',
            },
            rules: {
              pass: [
                { required: true, message: '请输入密码', trigger: 'blur' },
              ],
              username: [
                { required: true, message: '请输入用户名', trigger: 'blur' },
              ]
            }
          }
      },
      methods:{
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              let param = {
                username: this.ruleForm.username,
                subnick:"",
                secret: this.ruleForm.pass
              }
              console.log(this.ruleForm.username);
              $api.get("/admlogin", param, response => {
                let dataResult = response.data;
                if (dataResult.state == 1 && dataResult.message == "ok") {
                  storage.set("admin", dataResult.data.admin);
                  storage.set("subnick", "");
                  storage.set("days",0);
                  storage.set("pass", dataResult.data.pass);
                  console.log('submit!!');
                  this.$router.replace({name: 'AdmAccess'})
                }else{
                  this.$message.error(dataResult);
                }
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/admin/AdmLogin.vue